import React from 'react';


function Banner() {
    return (
        <div>
            <div className="mycontainer manage-workflow-box">
                <div className="row">
                    <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="createworkflowsection1">
                            <h4>Comparison</h4>
                            <p>Admin can compare and approve forecast values and planned values from sales person.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Banner